// extracted by mini-css-extract-plugin
module.exports =  {"CommonPage":"CommonPage__QLIrv"};